import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    Card, CardBody, Col,
} from 'reactstrap';
import ReactTableBase from '../../../shared/components/table/ReactTableBase';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { formatNumber } from '../../Utils/Money';
import moment from 'moment';

const reorder = (rows, startIndex, endIndex) => {
    const result = Array.from(rows);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};

const ReportPatientsTable = ({ title, reactTableData, ReactTableActions, goToAdmision, goToInvoice, goToCashReceipt, getNotaCredito, handleFilterValue }) => {
    const { t } = useTranslation('common');

    const [rows, setData] = useState(reactTableData);
    const [isEditable, setIsEditable] = useState(false);
    const [isResizable, setIsResizable] = useState(false);
    const [isSortable, setIsSortable] = useState(false);
    const [isDisabledDragAndDrop, setIsDisabledDragAndDrop] = useState(false);
    const [isDisabledEditable, setIsDisabledEditable] = useState(false);
    const [isDisabledResizable, setIsDisabledResizable] = useState(false);
    const [withDragAndDrop, setWithDragAndDrop] = useState(false);
    const [withPagination, setWithPaginationTable] = useState(true);
    const [withSearchEngine, setWithSearchEngine] = useState(true);

    const handleClickIsEditable = () => {
        if (!withDragAndDrop) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setIsEditable(!isEditable);
    };
    const handleClickIsResizable = () => {
        setIsEditable(false);
        setWithDragAndDrop(false);
        setIsDisabledDragAndDrop(!isDisabledDragAndDrop);
        setIsDisabledEditable(!isDisabledEditable);
        setIsResizable(!isResizable);
    };
    const handleClickIsSortable = () => {
        setIsSortable(!isSortable);
    };
    const handleClickWithDragAndDrop = () => {
        if (!isEditable) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setWithDragAndDrop(!withDragAndDrop);
    };
    const handleClickWithPagination = () => {
        setWithPaginationTable(!withPagination);
    };
    const handleClickWithSearchEngine = () => {
        setWithSearchEngine(!withSearchEngine);
    };

    const updateDraggableData = (result) => {
        const items = reorder(
            rows,
            result.source.index,
            result.destination.index,
        );
        setData(items);
    };

    const updateEditableData = (rowIndex, columnId, value) => {
        setData(old => old.map((item, index) => {
            if (index === rowIndex) {
                return {
                    ...old[rowIndex],
                    [columnId]: value,
                };
            }
            return item;
        }));
    };

    const history = useHistory();

    const tableConfig = {
        isEditable,
        isResizable,
        isSortable,
        withDragAndDrop,
        withPagination,
        withSearchEngine,
        placeholder: 'Buscar Paciente',
        manualPageSize: [5, 10, 15, 20],
        /*useActions: true,
        actions: (data) => ReactTableActions({ data })*/
    };

    const columnsData = [
        {
            Header: "Fecha de Admisión",
            accessor: 'fecha_admision',
            Cell: row => (
                <div style={{ width: '100px' }}>
                    {row.value != null ? moment(row.value).format("DD/MM/YYYY") : "N/a"}
                </div>
            )
        },
        {
            Header: "Documento del Paciente",
            accessor: 'documento_paciente_concatenado',
            Cell: row => (
                <div style={{ width: '150px' }}>
                    {row.value != null && row.value != undefined && row.value != "" ? row.value : "N/a"}
                </div>
            )
        },
        {
            Header: "Paciente",
            accessor: 'nombre_paciente',
            Cell: row => (
                <div style={{ width: '250px' }}>
                    {row.value != null && row.value != undefined && row.value != "" ? row.value : "N/a"}
                </div>
            )
        },
        {
            Header: "Entidad",
            accessor: 'contrato_tercero',
            Cell: row => (
                <div style={{ width: '300px' }}>
                    {row.value != null && row.value != undefined && row.value != "" ? row.value : "N/a"}
                </div>
            )
        },
        {
            Header: "Autorización",
            accessor: 'codigo_autorizacion',
            Cell: row => (
                <div style={{ width: '120px' }}>
                    {row.value != null && row.value != undefined && row.value != "" ? row.value : "N/a"}
                </div>
            )
        },
        {
            Header: "Servicio",
            accessor: 'servicio_realizado',
            Cell: row => (
                <div style={{ width: '300px' }}>
                    {row.value != null && row.value != undefined && row.value != "" ? row.value : "N/a"}
                </div>
            )
        },
        {
            Header: "CUPS",
            accessor: 'cups_realizado',
            Cell: row => (
                <div style={{ width: '75px' }}>
                    {row.value != null && row.value != undefined && row.value != "" ? row.value : "N/a"}
                </div>
            )
        },
        {
            Header: "Nombre del Profesional",
            accessor: 'nombre_profesional',
            Cell: row => (
                <div style={{ width: '250px' }}>
                    {row.value != null && row.value != undefined && row.value != "" ? row.value : "N/a"}
                </div>
            )
        },
        {
            Header: "Admisión",
            accessor: 'id_admision',
            Cell: row => (
                <div style={{ width: '75px' }}>
                    {
                        row.value != null && row.value != undefined && row.value != "" ?  <a href='#' onClick={() => goToAdmision(parseInt(row.value))}>{row.value}</a> : "N/a"
                    }
                </div>
            )
        },
        {
            Header: "Estado de la Admisión",
            accessor: 'estado_admision',
            Cell: row => (
                <div style={{ width: '75px' }}>
                    {row.value != null && row.value != undefined ? row.value.toUpperCase() : "N/a"}
                </div>
            )
        },
        {
            Header: "Usuario Admisión",
            accessor: 'usuario_recepcion_nombre',
            Cell: row => (
                <div style={{ width: '250PX' }}>
                    {row.value != null && row.value != undefined && row.value != "" ? row.value : "N/a"}
                </div>
            )
        },
        {
            Header: "Reagendado",
            Cell: row => (
                <div style={{ width: '75px' }}>
                    {row.row.original.id_admision_padre != null && row.row.original.id_admision_padre != undefined ? "SI" : "NO"}
                </div>
            )
        },
        {
            Header: "Admisión Padre",
            accessor: 'id_admision_padre',
            Cell: row => (
                <div style={{ width: '75px' }}>
                    {row.value != null && row.value != undefined ? <div style={{ width: '75px' }}>
                        <a href='#' onClick={() => goToAdmision(parseInt(row.value))}>{row.value}</a>
                    </div> : "N/a"}
                </div>
            )
        },
        {
            Header: "Número de Recibo",
            accessor: 'num_recibo',
            Cell: row => (
                <div style={{ width: '100px' }}>
                    {row.value != null && row.value ? <a href='#' onClick={() => goToCashReceipt(row.cell.row.original.id_admision, row.cell.row.original.id_admision_padre)}>{row.value}</a> : "N/a"}
                </div>
            )
        },
        {
            Header: "Usuario Cajero",
            accessor: 'usuario_cajero',
            Cell: row => (
                <div style={{ width: '250px' }}>
                    {row.value != null && row.value != undefined && row.value != "" ? row.value : "N/a"}
                </div>
            )
        },
        {
            Header: "Recibo Cancelado",
            accessor: 'recibo_cancelado',
            Cell: row => (
                <div style={{ width: '250px' }}>
                    {row.value == true ? "SI" : "NO"}
                </div>
            )
        },
        /*****/
        {
            Header: "Fecha Aplicación Radiofarmaco",
            accessor: 'fecha_aplicacion_radiofarmaco',
            Cell: row => (
                <div style={{ width: '150px' }}>
                    {row.value != null && row.value != undefined && row.value != "" ? moment(row.value).format("DD/MM/YYYY") : "N/a"}
                </div>
            )
        },
        {
            Header: "Radiofarmaco Aplicado",
            accessor: 'radiofarmaco_aplicado_admision',
            Cell: row => (
                <div style={{ width: '150px' }}>
                    {row.value != null && row.value != undefined && row.value != "" ? row.value : "N/a"}
                </div>
            )
        },
        {
            Header: "Dosis Radiofarmaco",
            accessor: 'dosis_radiofarmaco_admision',
            Cell: row => (
                <div style={{ width: '150px' }}>
                    {row.value != null && row.value != undefined && row.value != "" ? row.value : "N/a"}
                </div>
            )
        },
        /****/
        {
            Header: "Tecnologo",
            accessor: 'tecnologo_admision',
            Cell: row => (
                <div style={{ width: '150px' }}>
                    {row.value != null && row.value != undefined && row.value != "" ? row.value : "N/a"}
                </div>
            )
        },
        {
            Header: "Imagenes Tecnologo",
            accessor: 'imagenes_diagnosticas_data',
            Cell: row => (
                <div style={{ width: '75px' }}>
                    {row.value != null && row.value != undefined && row.value != "" ? row.value : "N/a"}
                </div>
            )
        },
        {
            Header: "Fecha y Hora Ultima Subida de Imagenes",
            accessor: 'fecha_ultima_imagen',
            Cell: row => (
                <div style={{ width: '75px' }}>
                    {row.value != null && row.value != undefined && row.value != "" ? row.value : "N/a"}
                </div>
            )
        },
        {
            Header: "Imagenes Profesional",
            accessor: 'estado_imagenes_doctor',
            Cell: row => (
                <div style={{ width: '130px' }}>
                    {row.value != null && row.value != undefined && row.value != "" ? row.value : "N/a"}
                </div>
            )
        },
        {
            Header: "Posee Transcripcion",
            accessor: 'estado_transcripcion',
            Cell: row => (
                <div style={{ width: '75px' }}>
                    {row.value != null && row.value != undefined && row.value != "" ? row.value : "N/a"}
                </div>
            )
        },
        {
            Header: "Factura",
            accessor: 'num_fac_ter',
            Cell: row => (
                <div style={{ width: '150px' }}>
                    {row.value != null && row.value != undefined ? <a href='#' onClick={() => goToInvoice(row.value, row.cell.row.original.nota_credito)}>{row.value}</a> : "N/a"}
                </div>
            )
        },
        {
            Header: "Nombre de Usuario Facturador",
            accessor: 'nombre_usuario_facturador',
            Cell: row => (
                <div style={{ width: '150px' }}>
                    {row.value != null && row.value != undefined && row.value != "" ? row.value : "N/a"}
                </div>
            )
        },
        {
            Header: "Fecha de Radicación",
            accessor: 'fecha_radicacion',
            Cell: row => (
                <div style={{ width: '75px' }}>
                    {row.value != null ? moment(row.value).format("DD/MM/YYYY") : "N/a"}
                </div>
            )
        },
        {
            Header: "Fecha de Vencimiento",
            accessor: 'fecha_vencimiento',
            Cell: row => (
                <div style={{ width: '75px' }}>
                    {row.value != null ? moment(row.value).format("DD/MM/YYYY") : "N/a"}
                </div>
            )
        },
        {
            Header: "Nota Crédito",
            accessor: 'nota_credito',
            Cell: row => (
                <div style={{ width: '75px' }}>
                    {row.value != null && row.value != undefined && row.value != "" ? row.value : "N/a"}
                </div>
            )
        },
        {
            Header: "Total Facturado",
            accessor: 'costo_admision',
            Cell: row => (
                <div style={{ width: '100px' }}>
                    {`$ ${formatNumber(row.value)}`}
                </div>
            )
        },
        {
            Header: "Recibido",
            accessor: 'copago_recibo',
            Cell: row => (
                <div style={{ width: '100px' }}>
                    {`$ ${formatNumber(row.value)}`}
                </div>
            )
        },
        {
            Header: "Total Entidad",
            accessor: 'total_recibo',
            Cell: row => (
                <div style={{ width: '100px' }}>
                    {`$ ${formatNumber(row.value)}`}
                </div>
            )
        },
    ];

    const handleValue = (value) => {
        handleFilterValue(value);
    }

    useEffect(() => {
    }, []);


    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div className="react-table__wrapper">

                    </div>
                    <ReactTableBase
                        key={withSearchEngine || isResizable || isEditable ? 'modified' : 'common'}
                        columns={columnsData}
                        data={rows}
                        updateEditableData={updateEditableData}
                        updateDraggableData={updateDraggableData}
                        tableConfig={tableConfig}
                        handleValue={handleValue}
                    />
                </CardBody>
            </Card>
        </Col>
    );
};

ReportPatientsTable.propTypes = {
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableHeaderData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableRowData: PropTypes.arrayOf(PropTypes.shape())
};

export default ReportPatientsTable;
